export const settingsRateLimitValidator = (t, min, max) => (input) => {
    let err = null;
    const parsedInput = parseInt(input, 10);
    if (!input.match(/^\d+$/)) {
        err = t('settings.request-rates-and-limits.validation.settings-rate-limit-invalid-integer');
    } else if (parsedInput < min) {
        err = t('settings.request-rates-and-limits.validation.settings-rate-limit-lower-than-min', { min });
    } else if (parsedInput > max) {
        err = t('settings.request-rates-and-limits.validation.settings-rate-limit-greater-than-max', { max });
    }
    return err;
};

export const CLIENT_APPLICATION_ID_MAX_LENGTH = 32;
export const settingsApplicationIdValidator = (t, clientApplications) => (input) => {
    let err = null;
    if (!input || input.trim().length === 0) {
        err = t('settings.client-applications.validation.application-id-empty');
    } else if (input.length > CLIENT_APPLICATION_ID_MAX_LENGTH) {
        err = t('settings.client-applications.validation.application-id-too-long', { maxLetters: CLIENT_APPLICATION_ID_MAX_LENGTH });
    } else if (clientApplications.some((clientApplication) => clientApplication.applicationId === input.trim())) {
        err = t('settings.client-applications.validation.application-id-already-in-use', { applicationId: input.trim() });
    }
    return err;
};

export const CLIENT_APPLICATION_DESCRIPTION_MAX_LENGTH = 64;
export const settingsApplicationDescriptionValidator = (t) => (input) => {
    let err = null;
    if (input.length > CLIENT_APPLICATION_DESCRIPTION_MAX_LENGTH) {
        err = t('settings.client-applications.validation.application-description-too-long', { maxLetters: CLIENT_APPLICATION_DESCRIPTION_MAX_LENGTH });
    }
    return err;
};
